"use client";
import {Box, Button, Center, Divider} from "@chakra-ui/react";
import SimpleIntro from "@/components/simpleIntro";
import {BUTTON_VARIANTS} from "@/theme/components/button";
import {scrollToElement} from "@/utils/scrollToElement";
import {INTRO_CONSTANTS} from "./constants";

const IntroComponent = () => {
  return (
    <Box>
      <SimpleIntro {...INTRO_CONSTANTS} />
      <Center>
        <Button
          variant={BUTTON_VARIANTS.IDEAL}
          onClick={() => scrollToElement("pricing", 120)}
          mt={8}
        >
          {INTRO_CONSTANTS.btnText}
        </Button>
      </Center>
      <Divider borderWidth="2px" borderColor="#ECECEC" mt={10} mb={{base: -10, md: 0}} />
    </Box>
  );
};

export default IntroComponent;
